import * as React from "react";
const SvgWarningTriangle = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 1.93c-.004 0-2.282 4.432-5.064 9.85-2.783 5.417-5.061 9.857-5.063 9.865-.003.011 1.393.013 10.127.013 8.72 0 10.13-.002 10.127-.013C22.122 21.62 12.007 1.93 12 1.93Zm0 3.283c.004 0 7.655 14.897 7.668 14.93.002.004-3.448.007-7.668.007-4.22 0-7.672-.003-7.67-.007A24507.665 24507.665 0 0 1 12 5.213Zm-.748 4.445v6.096h1.496V9.658H12Zm0 7.967v1.412h1.496v-1.412H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgWarningTriangle;
